<template>
  <div class="filter__saving">
    <!-- button -->
    <div class="d-flex justify-content-center mb-2">
      <button
        class="btn btn-primary btn-sm w-100 js-dl-cta px-1"
        data-dl-type="Uložit filtr - button"
        role="button"
        data-bs-toggle="modal"
        data-bs-target="#savedFilterModal"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {{ saveFilterLabel }}
      </button>
    </div>

    <p class="text-center text--small text--400 px-lg-4 mb-0" v-html="saveFilterNoteLabel"></p>
  </div>
</template>

<script setup>
// Props
const props = defineProps({
  saveFilterLabel: {
    type: String,
    default: 'Uložit filtr'
  },
  saveFilterNoteLabel: {
    type: String,
    default: 'Uložte si filtr a dostávejte upozornění na nové vozy'
  }
})
</script>
